import { useEffect, useState } from 'react';
import { useBlocker } from 'react-router-dom';

import { useConfirmModal } from '@sternum/web/components/ConfirmModal/useConfirmModal';

import { DiscardDialogProps } from './DiscardDialog.data';
import { DiscardDialogEmitter } from './DiscardDialog.emitter';

export function DiscardDialogProvider() {
  const [ConfirmModal, showModal, hideModal] = useConfirmModal();
  const [shouldBlock, setShouldBlock] = useState(false);
  const [dialogProps, setDialogProps] = useState<DiscardDialogProps>({});

  const { proceed, reset, state } = useBlocker(
    ({ currentLocation, nextLocation }) => shouldBlock && currentLocation.pathname !== nextLocation.pathname,
  );

  useEffect(() => {
    if (state === 'blocked') {
      showModal().then((result) => {
        if (result) {
          proceed();
        } else {
          reset();
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  useEffect(() => {
    const onShow = async () => {
      const result = await showModal();

      DiscardDialogEmitter.emit('result', result);
    };

    const onHide = () => {
      hideModal();
    };

    const onBlock = () => {
      setShouldBlock(true);
    };

    const onUnblock = () => {
      setShouldBlock(false);
    };

    const onMessage = (message: DiscardDialogProps) => {
      setDialogProps(message);
    };

    DiscardDialogEmitter.addListener('show', onShow);
    DiscardDialogEmitter.addListener('hide', onHide);
    DiscardDialogEmitter.addListener('block', onBlock);
    DiscardDialogEmitter.addListener('unblock', onUnblock);
    DiscardDialogEmitter.addListener('message', onMessage);

    return () => {
      DiscardDialogEmitter.removeListener('show', onShow);
      DiscardDialogEmitter.removeListener('hide', onHide);
      DiscardDialogEmitter.removeListener('block', onBlock);
      DiscardDialogEmitter.removeListener('unblock', onUnblock);
      DiscardDialogEmitter.removeListener('message', onMessage);
    };
  }, [hideModal, showModal]);

  return <ConfirmModal {...dialogProps} />;
}
